import { Badge, Box, Button, Group, Menu, ScrollArea, Text, TextInput } from "@mantine/core";
import { IDropdownFilterOption } from "@mctypes/frontend.types";
import { IconCheck, IconChevronDown, IconCircleCheck, IconX } from "@tabler/icons-react";
import React, { Fragment } from "react";
import { sortArrayByString } from "../../app/utils";

const DropdownFilter: React.FC<{
  filterOptions: IDropdownFilterOption[];
  title: string;
  onClick?: (title: string, value: string) => void;
  enableSearch?: boolean;
  unSelectAll?: () => void;
  selectAll?: () => void;
  color?: string;
  variant?: string;
}> = ({
  filterOptions,
  title,
  onClick,
  enableSearch = false,
  unSelectAll,
  selectAll,
  color = "white",
  variant = "outline",
}) => {
  const numberOfActiveFilters = filterOptions.filter((option) => option.isActive === true).length;
  const [searchValue, setSearchValue] = React.useState<string>("");
  const notAssigned = "Ikke tildelt";

  const buttonColor = numberOfActiveFilters > 0 ? "mc-primary" : "warmgray.6";

  return (
    <Box style={{ whiteSpace: "nowrap" }}>
      <Menu width={220} shadow="sm" position="bottom-start" withinPortal closeOnItemClick={false}>
        <Menu.Target>
          <Button
            px="xs"
            variant={variant}
            color={buttonColor}
            bg={numberOfActiveFilters > 0 ? "#e8eef4" : "white"}
            size="sm"
            rightSection={<IconChevronDown size={16} />}
            style={{ display: "flex", alignItems: "center" }}
          >
            <Group gap={6} align="center" wrap="nowrap">
              <Text>{title}</Text>
              {numberOfActiveFilters > 0 && (
                <Badge size="xs" fz={"xs"} circle w="fit-content" miw={16}>
                  {" "}
                  {numberOfActiveFilters}
                </Badge>
              )}
            </Group>
          </Button>
        </Menu.Target>
        <Menu.Dropdown>
          {enableSearch && (
            <TextInput
              autoFocus
              placeholder="Søk"
              value={searchValue}
              onChange={(e) => setSearchValue(e.currentTarget.value)}
              size="sm"
            />
          )}
          {enableSearch && <Menu.Divider />}
          <ScrollArea style={{ maxHeight: "200px", overflowY: "auto" }} type="auto">
            {sortArrayByString(filterOptions || [], "label")
              .filter((item) => item.label != null && item.value != null)
              .filter((item) =>
                !enableSearch || searchValue === ""
                  ? true
                  : item.label?.toLowerCase().includes(searchValue?.toLowerCase()),
              )
              .sort((a, b) => {
                if (a.label === notAssigned) return 1;
                if (b.label === notAssigned) return -1;
                return 0;
              })
              .map((option, i) => (
                <Fragment key={i}>
                  {option.label === notAssigned && <Menu.Divider />}
                  <Menu.Item
                    style={{ fontSize: ".9em" }}
                    onClick={() => onClick?.(title, option.value)}
                    color={option.isActive ? "mc-primary" : undefined}
                    rightSection={option.isActive ? <IconCheck size={16} /> : null}
                  >
                    {option.label}
                  </Menu.Item>
                </Fragment>
              ))}
          </ScrollArea>
          {(unSelectAll != null || typeof selectAll === "function") && <Menu.Divider />}
          {unSelectAll != null && (
            <Menu.Item style={{ fontSize: ".9em" }} onClick={() => unSelectAll()} leftSection={<IconX size={16} />}>
              Avmarker alle
            </Menu.Item>
          )}
          {typeof selectAll === "function" && (
            <Menu.Item
              style={{ fontSize: ".9em" }}
              onClick={() => selectAll()}
              leftSection={<IconCircleCheck size={16} />}
            >
              Marker alle
            </Menu.Item>
          )}
        </Menu.Dropdown>
      </Menu>
    </Box>
  );
};

export default DropdownFilter;

export const CircleWithNumber: React.FC<{ count: number; hide: boolean }> = ({ count, hide }) => {
  return (
    <Box bg={"mc-primary"} fz={"10px"} style={{ opacity: hide === true ? 0 : 1 }} className="circle-singleline">
      {count}
    </Box>
  );
};
